import { Link } from "react-router-dom";
import { categoryName, facts } from "@/mocks/articles";
import { VerdictBadge } from "@/components/base/ArticleCard";
import Breadcrumb, { Footer } from "@/components/feature/Footer";
import Navbar from "@/components/feature/Navbar";
import JsonLd from "@/components/base/JsonLd";
import useSeo from "@/hooks/useSeo";

const FAQS = [
  {
    q: "“免费爆料”真的能免费看吗？有没有坑？",
    a: "多数所谓“免费爆料”指免费浏览，但账号常用“免费”引流，后续转向付费社群、商品带货或索取个人联系方式。辨真社只做信息核查，不索要任何费用或隐私信息。",
  },
  {
    q: "网站说的“实锤 / 存疑 / 已辟谣”依据是什么？",
    a: "“实锤”指证据链完整、来源可溯、多方对撞一致；“已辟谣”指经溯源确认内容失实、摆拍或合成；“存疑”则指既无法证实也难以证伪，等待更多公开信息。三者的区分完全以公开证据为准。",
  },
  {
    q: "你们会编造结论吗？",
    a: "不会。本站每一条核验都尽可能附上可追溯的来源与推理过程。凡证据不足的，我们会如实标为“待考证”，绝不为了流量给出缺乏依据的定论。",
  },
  {
    q: "我吃到一个“大瓜”，怎么知道是不是真的？",
    a: "可以先套用鉴别指南里的 8 项自查清单，再从“看来源、核证据、多方对撞、分析动机”四个维度初筛。如果仍无法判断，欢迎投稿给辨真社，由我们帮你梳理证据链。",
  },
  {
    q: "你们的结论会不会被厂商、明星“公关”掉？",
    a: "我们坚持独立判断，结论只对证据负责，不对任何一方负责。同时我们也会如实在文中标注仍待确认的部分，接受读者用新证据进行修正。",
  },
  {
    q: "看到已被辟谣的内容还在传，我能做什么？",
    a: "可以在转发前先核对来源，避免二次扩散。也可把本站的核验链接发给转发者，帮助澄清。传播正确信息、指出明显疑点，就是对抗谣言最有效的日常动作。",
  },
  {
    q: "投稿核验需要付费或提供隐私吗？",
    a: "不需要。投稿只需说明事件背景和你掌握的证据线索即可，我们会隐去不必要的个人隐私信息后再进行公开梳理。",
  },
  {
    q: "你们的内容能作为法律或商业决策依据吗？",
    a: "不能。本站内容属于网络信息的整理与科普，仅供阅读参考，不构成法律意见或投资建议。重大事项请以官方机构与权威渠道为准。",
  },
];

export default function Faq() {
  useSeo(
    "常见问题 · 免费爆料真假与可信度问答 · 辨真社",
    "关于辨真社核验机制、免费爆料可信度、自查方法与投稿流程的常见问答，帮你看懂我们的结论，也学会自己辨别瓜料真伪。"
  );
  const samples = facts.slice(0, 3);

  return (
    <>
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: FAQS.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }}
      />
      <Navbar />
      <main>
        <section className="border-b border-background-200 bg-background-100">
          <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
            <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "常见问题" }]} />
            <h1 className="mt-5 font-heading text-3xl font-black text-foreground-950 md:text-5xl">
              常见问题
            </h1>
            <p className="mt-3 max-w-2xl text-base leading-relaxed text-foreground-700">
              关于辨真社怎么核验、结论如何分级、投稿要不要花钱……这些读者最常问的事，这里一次说清。
            </p>
          </div>
        </section>

        <section className="mx-auto max-w-4xl px-4 py-12 md:px-6 md:py-16">
          <div className="space-y-4">
            {FAQS.map((f) => (
              <div key={f.q} className="rounded-lg border border-background-200 bg-background-50 p-6">
                <h2 className="flex items-start gap-3 font-heading text-lg font-bold leading-snug text-foreground-950">
                  <span className="mt-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-600 text-sm text-background-50">
                    <i className="ri-question-line" />
                  </span>
                  {f.q}
                </h2>
                <p className="mt-3 pl-10 text-base leading-relaxed text-foreground-700">{f.a}</p>
              </div>
            ))}
          </div>

          <div className="mt-10 flex flex-col items-center gap-4 rounded-lg border border-background-200 bg-secondary-100/60 px-6 py-8 text-center md:flex-row md:justify-between md:px-8 md:text-left">
            <div>
              <h3 className="font-heading text-lg font-bold text-foreground-950">没解决你的问题？</h3>
              <p className="mt-1 text-sm text-foreground-700">可以邮件联系我们：feedback@bianzhenshe.example</p>
            </div>
            <Link to="/about" className="inline-flex h-11 shrink-0 items-center justify-center whitespace-nowrap rounded-md bg-foreground-950 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800">
              了解辨真社
            </Link>
          </div>

          <div className="mt-12">
            <h2 className="font-heading text-xl font-bold text-foreground-950">延伸阅读 · 去看看怎么核验</h2>
            <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
              {samples.map((a) => (
                <Link key={a.slug} to={`/article/${a.slug}`} className="group rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-secondary-300">
                  <div className="flex items-center gap-2">
                    <VerdictBadge verdict={a.verdict} size="sm" />
                    <span className="text-xs text-foreground-600">{categoryName(a.category)}</span>
                  </div>
                  <p className="mt-3 line-clamp-2 text-sm font-medium leading-snug text-foreground-900 group-hover:text-primary-700">
                    {a.title}
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}